import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { OrgRoleFilterFragmentDoc } from '../../fragment/generated/OrgRoleFilter';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRoleFilterQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.OrgRolesFilters>;
}>;


export type OrgRoleFilterQuery = { orgRoles: { pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, track?: { id: string, name: string, isAutomaticTrack: boolean } | null } }> | null } };


export const OrgRoleFilterDocument = /*#__PURE__*/ gql`
    query orgRoleFilter($sort: [SortType!], $after: String, $first: Float, $filters: OrgRolesFilters) {
  orgRoles(sort: $sort, after: $after, first: $first, filters: $filters) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...OrgRoleFilter
      }
    }
  }
}
    ${OrgRoleFilterFragmentDoc}`;

export function useOrgRoleFilterQuery(options?: Omit<Urql.UseQueryArgs<OrgRoleFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<OrgRoleFilterQuery, OrgRoleFilterQueryVariables>({ query: OrgRoleFilterDocument, ...options });
};